/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import POSContext from "./POSContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";

const headCells = [
    { index: 1, id: "id", disablePadding: false, label: "ID" },
    { index: 2, id: "dateString", orderBy: "date", disablePadding: true, label: "Date" },
    { index: 3, id: "userName", disablePadding: false, label: "Responsible" },
    { index: 4, id: "totalAmount", disablePadding: false, type: "currency", label: "Total Amount", numeric: true },
    { index: 5, id: "numberOfPayments", disablePadding: false, label: "Number of Payments" },
];

function List({ history }) {
    const classes = useStyles();
    const { user } = useSelector((state) => state.Login);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);

    const { Master, setIsUserCreating } = useContext(POSContext);

    function getPOSEntries(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Master.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getPOSEntries();
        setIsUserCreating(false);

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/pos/${item.id}/update`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getPOSEntries();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Master.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="POS">
                        <div className="button-group">
                            <Button primary onClick={() => history.push("/pos/add")}>
                                <Icon name="add" size="md" color="white" />
                                <span>Add</span>
                            </Button>
                            <Button primary outline onClick={() => history.push("/pos/reports")}>
                                View reports
                            </Button>
                        </div>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            title="POS"
                            dense={false}
                            defaultOrder={{ order: "desc", orderBy: "date" }}
                            keyColumnName="id"
                            selectable={user.isAdmin}
                            deletable={user.isAdmin}
                            onRowClick={onRowClickHandler}
                            onDelete={user.isAdmin && onDeleteHandler}
                            onRequestData={getPOSEntries}
                            pageableData={pageableData}
                            defaultRowsPerPage={5}
                            filterable={false}
                            orderable={false}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
